import { render, staticRenderFns } from "./DirectContinue.vue?vue&type=template&id=965879ac"
import script from "./DirectContinue.vue?vue&type=script&lang=js"
export * from "./DirectContinue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports